import PerkService from '../services/PerkService';
import MerchantService from '../services/MerchantService';
import ErrorHandler from '../helpers/ErrorHandler';
import {NotificationManager} from 'react-notifications';
import PerkConstants from '../constants/PerkConstants';
import {hashHistory} from 'react-router';
import {actions} from "react-redux-form";

export default {
  getList: (filter) => dispatch => {
    dispatch({type: 'ON_BUSY'});
    PerkService.list(filter).then((response) => {
      dispatch({type: 'OFF_BUSY'});
      dispatch({
        type: PerkConstants.PERK_GET_LIST,
        payload: response.perks
      })
    }, (err) => {
      dispatch({type: 'OFF_BUSY'});
      ErrorHandler(err)
    })
  },
  getCount: () => dispatch => {
    PerkService.getCount().then((response) => {
      dispatch({
        type: PerkConstants.PERK_GET_COUNT,
        payload: response.count
      })
    }, (err) => {
      ErrorHandler(err)
    })
  },
  get: (id) => dispatch => {
    dispatch({type: 'ON_BUSY'});
    PerkService.get(id).then((response) => {
      MerchantService.get().then((response_merchant) => {
        PerkService.list().then((response_perks) => {
          dispatch({type: 'OFF_BUSY'});
          response.perk.bonus_perks = response_perks.perks.filter(perk => perk.id !== id && perk.referral_bonus);
          response.perk.merchant = response_merchant.merchant;
          dispatch({
            type: PerkConstants.PERK_GET,
            payload: response.perk,
          });
          dispatch(actions.change('forms.perkForm', {
            id: response.perk.id ? response.perk.id : '',
            title: response.perk.title ? response.perk.title : '',
            description: response.perk.description ? response.perk.description : '',
            referral_bonus: response.perk.referral_bonus ? response.perk.referral_bonus : '',
            fine_print: response.perk.fine_print ? response.perk.fine_print : '',
            required_referrals: response.perk.required_referrals ? response.perk.required_referrals : '',
            expire_date: response.perk.expire_date ? response.perk.expire_date : '',
            receiver_perk_id: response.perk.receiver_perk_id ? response.perk.receiver_perk_id : '',
            bonus_perks: response.perk.bonus_perks ? response.perk.bonus_perks : '',
            merchant: response.perk.merchant ? response.perk.merchant : '',
          }));
        }, (err) => {
          dispatch({type: 'OFF_BUSY'});
          ErrorHandler(err)
        })
      }, (err) => {
        dispatch({type: 'OFF_BUSY'});
        ErrorHandler(err)
      })
    }, (err) => {
      dispatch({type: 'OFF_BUSY'});
      ErrorHandler(err)
    })
  },

  getBonusPerks: () => dispatch => {
    dispatch({type: 'ON_BUSY'});
    PerkService.list().then((response_perks) => {
      MerchantService.get().then((response_merchant) => {
        dispatch({type: 'OFF_BUSY'});
        var perk = Object.create({merchant: '', bonus_perks: []});
        perk.bonus_perks = response_perks.perks.filter(perk => perk.referral_bonus);
        perk.merchant = response_merchant.merchant;
        dispatch({
          type: PerkConstants.PERK_GET,
          payload: perk,
        })
      }, (err) => {
        dispatch({type: 'OFF_BUSY'});
        ErrorHandler(err)
      })
    }, (err) => {
      dispatch({type: 'OFF_BUSY'});
      ErrorHandler(err)
    })
  },

  add: (data) => dispatch => {
    PerkService.create(data).then((response) => {
      dispatch({type: PerkConstants.PERK_POST, payload: response});
      hashHistory.push('/perks/' + response.perk.id + '/view');
      NotificationManager.success(`Perk added.`);
    }, (err) => {
      ErrorHandler(err);
    })
  },

  edit: (data) => dispatch => {
    dispatch({type: 'ON_BUSY'});
    PerkService.update(data).then((response) => {
      dispatch({type: 'OFF_BUSY'});
      dispatch({
        type: PerkConstants.PERK_PUT,
        payload: response
      });
      hashHistory.push('/perks/' + data.id + '/view');
      NotificationManager.success(`Perk edited.`);
    }, (err) => {
      dispatch({type: 'OFF_BUSY'});
      ErrorHandler(err);
    })
  },
  deletePerk: (id) => dispatch => {
    dispatch({type: 'ON_BUSY'});
    PerkService.delete(id).then(() => {
      dispatch({type: 'OFF_BUSY'});
      dispatch({
        type: PerkConstants.PERK_DELETE,
        payload: id
      });
      NotificationManager.success(`Perk deleted.`);
    }, (err) => {
      dispatch({type: 'OFF_BUSY'});
      ErrorHandler(err);
    })
  }
}


/** WEBPACK FOOTER **
 ** ./src/actions/PerkAction.js
 **/